<template>
  <section>
    <TabsSwitchBar
      v-model="taskType"
      :tabs="taskTypeTabs"
      :role-class="setColorByRole"
      :mobile-equal="true"
    />

    <div class="data__filter">
      <DataSlider
        type="year"
        :items="monthItems"
        :model-value="selectedMonth"
        :dont-select="isDateSelected"
        :border-bottom="false"
        @change="onMonthChange"
      />
      <AllTasksFilter
        v-if="heightSize >= 950 || filterShow"
        :status-list="statusList"
        :subject-list="subjectList"
        :height-size="heightSize"
        :subject="subject"
        :status="status"
        :date="date"
        @apply="applyFilter"
        @clear="clearFilter"
      />
    </div>

    <QueryErrorNotice :error="allTasksPageErrors" />

    <div v-if="showAlertDanger || checkToEmpty()" class="empty-wrap">
      <EmptyStateNotice
        :text="
          filtering ? `${t('noneToShow')[0]}. ${t('noneToShow')[1]}` : t('emptyTasks')
        "
        variant="info"
      />
    </div>

    <div v-else class="ltasks__body">
      <div v-for="(dateTasks, i) in groupedTasks" :key="`g-${i}`">
        <div class="resttime" v-if="checkForStatus(dateTasks.tasks) && !filtering">
          <span>{{ formatGroupDate(dateTasks.date) }}</span>
        </div>

        <div
          v-for="(item, j) in dateTasks.tasks"
          :key="`t-${i}-${j}`"
          class="task__item"
          :class="getBg(item).bg"
        >
          <template v-if="isVisibleTask(item)">
            <button
              class="acc-item"
              :class="{
                'is-open': isTaskOpen(item.id),
                'border-line-bottom': isLastBorder(dateTasks, item),
              }"
              type="button"
              @click="toggleTask(item.id)"
            >
              <div>
                <p class="f-14 mb-0 bold task__item-title">{{ item.name }}</p>
                <div class="f-12 d-flex flex-column">
                  <span class="task__item-subject">{{ item.subject[localLang] }}</span>
                  <span class="status red--color" v-if="taskEndDate(item).status">
                    {{ taskEndDate(item).text }} {{ taskEndDate(item).date }}
                  </span>
                </div>
              </div>
              <div class="acc-icon">
                <span class="material-icons">keyboard_arrow_down</span>
              </div>
            </button>

            <div
              class="message-alert"
              :class="getBg(item).bg"
              v-if="getStatus(item).num === 3 && getComment(item)"
            >
              <p class="bold mb-2 f-14">{{ t("commentTask") }}</p>
              <p class="mb-0 f-13">{{ getComment(item) }}</p>
            </div>

            <div v-if="isTaskOpen(item.id)" class="task-expanded">
              <div class="task__header">
                <div class="task__header__title">
                  <h1 class="task__title">{{ item.name }}</h1>
                  <h3 class="task__sub-title" v-if="Number(item.time) !== -1">
                    {{ t("timeToReady") }}: {{ item.time }}
                  </h3>
                </div>
                <div
                  v-if="item.content"
                  class="task__content"
                  v-html="item.content"
                  @click="onTaskContentClick"
                />
                <div class="mb-3" v-if="item.info && item.info.files && item.info.files.length">
                  <p class="f-13 bold mb-1">{{ t("uploadFile") }}</p>
                  <FileFilter
                    v-for="(file, fileIndex) in item.info.files"
                    :key="`task-info-file-${fileIndex}`"
                    :url="file.url"
                    :name="file.name"
                    :file="file"
                    @open-file-viewer="openFrame"
                  />
                </div>
                <div class="mb-3" v-else-if="item.files && item.files.length">
                  <p class="f-13 bold mb-1">{{ t("uploadFile") }}</p>
                  <FileFilter
                    v-for="(file, fileIndex) in item.files"
                    :key="`task-file-${fileIndex}`"
                    :url="file.url"
                    :name="file.name"
                    :file="file"
                    @open-file-viewer="openFrame"
                  />
                </div>
              </div>

              <div class="task__footer" v-if="parentRoleCheck(item)">
                <div class="answer__head">
                  <span class="f-14 bold">{{ t("answer") }}</span>
                  <button
                    v-if="
                      (getStatus(item).num === 1 || getStatus(item).num === 4) &&
                      roleId === 3
                    "
                    class="btn__revert"
                    type="button"
                    @click="revertTask(item)"
                  >
                    {{ t("revert") }}
                  </button>
                </div>

                <textarea
                  v-model="item.answer.text"
                  rows="5"
                  class="textarea"
                  :disabled="isAnswerDisabled(item)"
                />
                <p v-if="item.answer.text.length >= 2000">
                  <small class="text-danger">{{ t("maxAnswerError") }}</small>
                </p>

                <div
                  class="task__answer-files mb-3"
                  v-if="canEditAnswer(item) || item.answer.chat.length"
                >
                  <span class="f-13 bold">{{ t("uploadedFileInAnswer") }}</span>
                  <div
                    class="child_file--btn mt-2"
                    @click="checkMoreThen(item.answer.files.length)"
                  >
                    <input
                      :id="fileInputId(item.id)"
                      :ref="(el) => setFileInputRef(item.id, el)"
                      type="file"
                      multiple
                      :disabled="isFileUploadDisabled(item)"
                      accept=".txt,.htm,.html,.rtf,.doc,.docx,.xls,.xlsx,.pdf,.mp3,.waf,.mp4,.avi,.ppt,.pptx,.flipchart,.cptx,.zip,.gz,.rar,.flr,.flp,.svg,.jpg,.png,.gif,.jpeg,.tif,.tiff,.bmp"
                      @change="uploadFiles($event, item)"
                    />
                    <label :for="fileInputId(item.id)">
                      {{ t("uploadToAnswer") }}
                      <span class="material-icons ml-1">cloud_upload</span>
                    </label>
                  </div>
                </div>

                <div
                  v-for="(file, idx) in item.answer.files"
                  :key="`f-${idx}`"
                  class="d-flex justify-content-between align-items-center mb-3"
                >
                  <template v-if="!file.is_deleted">
                    <a
                      class="f-12"
                      :href="file.url"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ file.name }}</a
                    >
                    <div class="link-item--green d-flex align-items-center">
                      <span
                        class="material-icons link mx-3 green-icon"
                        @click="openFile(file)"
                        >cloud_download</span
                      >
                      <span
                        v-if="getByFileType(file)"
                        class="material-icons link mr-1 green-icon"
                        @click="openFrame(file)"
                        >launch</span
                      >
                      <span
                        class="material-icons mr-1"
                        v-if="canEditAnswer(item) && roleId === 3"
                        @click="removeFile(item, idx)"
                        >close</span
                      >
                    </div>
                  </template>
                </div>

                <div v-if="inProgress" class="progress-wrap mb-3">
                  <div class="progress">
                    <div class="progress-bar" :style="{ width: `${progress}%` }">
                      {{ progress }}%
                    </div>
                  </div>
                </div>

                <div
                  class="mb-3 chat__body"
                  v-if="canEditAnswer(item) || item.answer.chat.length"
                >
                  <div class="chat__msg">
                    <div class="mb-2 bold">{{ t("commentTask") }}:</div>
                    <div
                      v-for="(msg, mi) in item.answer.chat"
                      :key="`m-${mi}`"
                      class="msg__answer"
                    >
                      <div class="mb-1 ml-1 f-14">
                        <span>{{ msg.person_name }}:</span> <span>{{ msg.message }}</span>
                      </div>
                    </div>
                  </div>
                  <input
                    v-model="item.answer.childMessage"
                    class="input"
                    :disabled="isAnswerDisabled(item)"
                  />
                </div>

                <button
                  v-if="roleId === 3"
                  class="submit f-13 btn-custom"
                  :disabled="isSubmitDisabled(item)"
                  @click="submit(item)"
                >
                  {{ t("sendToCheck") }}
                </button>
              </div>

              <div v-else class="parentAlert">{{ t("parentAlert") }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <FileViewer v-model="iframe" />
  </section>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import AllTasksFilter from "@/components/all-tasks/AllTasksFilter.vue";
import DataSlider from "@/components/common/DataSlider.vue";
import EmptyStateNotice from "@/components/common/EmptyStateNotice.vue";
import FileFilter from "@/components/common/FileFilter.vue";
import FileViewer from "@/components/common/FileViewer.vue";
import QueryErrorNotice from "@/components/common/QueryErrorNotice.vue";
import TabsSwitchBar from "@/components/common/TabsSwitchBar.vue";
import {
  useAllTasksPlansQuery,
  useCreateTaskAnswerMutation,
  usePeriodsQuery,
  useUpdateTaskAnswerMutation,
  useUploadTaskFileMutation,
} from "@/queries";
import { useLoadingStore } from "@/stores/loading";
import { useTopbarStore } from "@/stores/topbar";
import { useViewerStore } from "@/stores/viewer";
import { parsePeriodsLegacy, toUtcDaySeconds } from "@/utils/periodSlider";

const { t, tm } = useI18n();
const route = useRoute();
const router = useRouter();
const topbarStore = useTopbarStore();
const loadingStore = useLoadingStore();
const viewerStore = useViewerStore();
viewerStore.initFromStorage();

const heightSize = ref(window.innerWidth);
const subject = ref(-1);
const date = ref("");
const status = ref(-1);
const filtering = ref(false);
const isDateSelected = ref(false);
const showAlertDanger = ref(false);
const filterShow = ref(false);
const taskType = ref("no_send");
const selectedMonth = ref(null);
const progress = ref(0);
const inProgress = ref(false);
const sending = ref(false);
const openedTaskIds = ref(new Set());
const allTasksFlat = ref([]);
const fileInputRefs = ref(new Map());
const iframe = ref({
  open: false,
  url: "",
  type: "",
});

const selectedChild = computed(() => viewerStore.selectedChild || null);
const roleId = computed(() => (viewerStore.isParent ? 2 : 3));
const localLang = computed(() =>
  localStorage.getItem("translation") === "kz" ? "kz" : "ru"
);
const selectedPupilId = computed(() =>
  Number(
    selectedChild.value?.pupil_id ||
      viewerStore.profile?.pupil_id ||
      viewerStore.profile?.group?.pupil_id ||
      0
  )
);
const selectedGroupId = computed(() =>
  Number(
    selectedChild.value?.group_id ||
      viewerStore.profile?.group_id ||
      viewerStore.profile?.group?.id ||
      0
  )
);
const lessonIdQuery = computed(() => Number(route.query.lessonId || 0));

const periodsQuery = usePeriodsQuery({}, { staleTime: 5 * 60 * 1000, retry: false });
const parsedPeriods = computed(() =>
  parsePeriodsLegacy(
    Array.isArray(periodsQuery.data.value) ? periodsQuery.data.value : []
  )
);
const monthItems = computed(() =>
  (parsedPeriods.value.months || []).map((m) => {
    const weeks = Array.isArray(m.weeks) ? m.weeks : [];
    const start = weeks.length ? Math.min(...weeks.map((w) => Number(w.start || 0))) : 0;
    const end = weeks.length ? Math.max(...weeks.map((w) => Number(w.end || 0))) : 0;
    return {
      month: m.month,
      year: m.year,
      title: capitalize(
        new Date(m.year, m.month, 1).toLocaleDateString(resolveLocale(), {
          month: "long",
        })
      ),
      start: toUtcDaySeconds(start),
      end: toUtcDaySeconds(end),
    };
  })
);

const selectedRange = computed(() => {
  if (isDateSelected.value && date.value) {
    const d = new Date(date.value);
    if (!Number.isNaN(d.getTime())) {
      const ts = toUtcDaySeconds(d);
      return { start: ts, end: ts };
    }
  }
  if (!selectedMonth.value) {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    return {
      start: toUtcDaySeconds(start),
      end: toUtcDaySeconds(end) + 24 * 60 * 60 - 1,
    };
  }
  return {
    start: Number(selectedMonth.value?.start || 0),
    end: Number(selectedMonth.value?.end || 0),
  };
});

const plansQuery = useAllTasksPlansQuery(
  computed(() => selectedRange.value.start),
  computed(() => selectedRange.value.end),
  selectedGroupId,
  selectedPupilId,
  {
    retry: false,
  }
);
const createAnswerMutation = useCreateTaskAnswerMutation();
const updateAnswerMutation = useUpdateTaskAnswerMutation();
const uploadFileMutation = useUploadTaskFileMutation();

const groupedTasks = computed(() => {
  const sorted = [...allTasksFlat.value].sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
  );
  const map = new Map();
  sorted.forEach((item) => {
    if (!map.has(item.date)) map.set(item.date, []);
    map.get(item.date).push(item);
  });
  return [...map.entries()].map(([day, tasks]) => ({ date: day, tasks }));
});
const noSendCount = computed(
  () =>
    allTasksFlat.value.filter((item) =>
      [0, 3, 6].includes(Number(item.answer?.status || 0))
    ).length
);
const sendCount = computed(
  () =>
    allTasksFlat.value.filter(
      (item) => ![0, 3, 6].includes(Number(item.answer?.status || 0))
    ).length
);
const subjectList = computed(() => {
  const map = new Map();
  allTasksFlat.value.forEach((item) => {
    const id = Number(item.subject_id || 0);
    if (!id || map.has(id)) return;
    map.set(id, { id, text: resolveSubjectName(item) });
  });
  return [...map.values()];
});
const statusList = computed(() => {
  const raw = tm("status");
  return Array.isArray(raw) ? raw : [];
});
const allTasksLabels = computed(() => {
  const raw = tm("allTasks");
  if (Array.isArray(raw)) return raw;
  return [t("allTasks.0"), t("allTasks.1")];
});
const taskTypeTabs = computed(() => [
  {
    value: "no_send",
    label: allTasksLabels.value[1] || "",
    shortLabel: allTasksLabels.value[1] || "",
    badge: Number(noSendCount.value || 0),
  },
  {
    value: "ready",
    label: allTasksLabels.value[0] || "",
    shortLabel: allTasksLabels.value[0] || "",
    badge: Number(sendCount.value || 0),
  },
]);

watch(
  () => plansQuery.data.value,
  (value) => {
    allTasksFlat.value = normalizeTasks(Array.isArray(value) ? value : []);
    checkToEmpty();
  },
  { immediate: true }
);

watch(
  () => [selectedPupilId.value, selectedGroupId.value],
  () => {
    allTasksFlat.value = [];
    openedTaskIds.value = new Set();
    showAlertDanger.value = false;
    if (selectedPupilId.value && selectedGroupId.value) {
      plansQuery.refetch();
    }
  }
);

watch(
  () => taskType.value,
  (value) => {
    if (value !== "filtering") {
      filtering.value = false;
      filterShow.value = false;
    }
    checkToEmpty();
  }
);

watch(
  () => monthItems.value,
  (items) => {
    if (!items.length) return;
    const now = new Date();
    let month = now.getMonth();
    if (month === 5 || month === 6 || month === 7) month = 4;
    selectedMonth.value = items.find((item) => item.month === month) || items[0];
  },
  { immediate: true }
);

const isLoading = computed(
  () =>
    periodsQuery.isFetching.value ||
    plansQuery.isFetching.value ||
    sending.value ||
    createAnswerMutation.isPending.value ||
    updateAnswerMutation.isPending.value
);
const allTasksPageErrors = computed(() =>
  [periodsQuery, plansQuery]
    .filter((query) => query.isError?.value)
    .map((query) => query.error?.value)
);
watch(
  () => isLoading.value,
  (v) => loadingStore.set("all-tasks-page", v),
  { immediate: true }
);

onMounted(() => {
  setTopbarButtons();
  window.addEventListener("resize", onResize);
});
onBeforeUnmount(() => {
  loadingStore.hide("all-tasks-page");
  window.removeEventListener("resize", onResize);
});

function setTopbarButtons() {
  topbarStore.clear();
  topbarStore.setTitle(t("tasksTitle"));
  topbarStore.addButton({
    type: "left",
    icon: "keyboard_backspace",
    action: () => {
      const isMobile = Number(heightSize.value || 0) < 768;
      if (isMobile && filterShow.value) {
        filterShow.value = false;
        return;
      }
      router.push("/schedule");
    },
  });
  topbarStore.addButton({
    type: "right",
    icon: "filter_alt",
    action: () => {
      filterShow.value = true;
    },
  });
}
function onResize() {
  heightSize.value = window.innerWidth;
}
function resolveLocale() {
  return localStorage.getItem("translation") === "kz" ? "kk-KZ" : "ru-RU";
}
function capitalize(v) {
  return v ? v.charAt(0).toUpperCase() + v.slice(1) : "";
}
function onMonthChange(v) {
  selectedMonth.value = v;
  isDateSelected.value = false;
  date.value = "";
}
function applyFilter(data) {
  filtering.value = true;
  taskType.value = "filtering";
  filterShow.value = false;
  subject.value = Number(data?.subject ?? -1);
  status.value = Number(data?.status ?? -1);
  date.value = data?.date || "";
  isDateSelected.value = Boolean(date.value);
}
function clearFilter() {
  subject.value = -1;
  date.value = "";
  status.value = -1;
  isDateSelected.value = false;
  filtering.value = false;
  filterShow.value = false;
  taskType.value = "no_send";
  showAlertDanger.value = false;
}
function normalizeTasks(plans) {
  const tasks = [];
  plans.forEach((plan) => {
    const ltasks = getPlanTasks(plan);
    const subjectData = plan?._data?.subject || plan?.subject || {};
    const planId = Number(plan?.id || plan?._id || plan?._data?.id || 0);
    ltasks.forEach((item) => {
      if (!isHavePupil(item?.pupils)) return;
      const sourceTask = item?.sdot_data || item || {};
      const task = JSON.parse(JSON.stringify(sourceTask));
      if (typeof task.info === "string") {
        try {
          task.info = JSON.parse(task.info);
        } catch {
          task.info = {};
        }
      }
      if (!task.info && typeof item?.info === "object") {
        task.info = item.info;
      }
      if (!Array.isArray(task.files) && Array.isArray(item?.files)) {
        task.files = item.files;
      }
      task.date = plan?.date;
      task.subject = task.subject || item?.subject || subjectData;
      task.subject_id = Number(plan?._data?.subject_id || task.subject_id || 0);
      task.end_date = item?.end_date || null;
      task.id = Number(task.id || item?.id || 0);
      task.name = task.name || item?.name || "";
      task.content = task.content || item?.content || "";
      task.time = task.time ?? item?.time ?? -1;
      task.answer = buildTaskAnswer(item);
      if (lessonIdQuery.value && planId !== lessonIdQuery.value) return;
      tasks.push(task);
    });
  });
  return tasks;
}

function getPlanTasks(plan) {
  if (Array.isArray(plan?._data?.ltasks)) return plan._data.ltasks;
  if (Array.isArray(plan?.ltasks)) return plan.ltasks;
  return [];
}
function buildTaskAnswer(rawTask) {
  const result = Array.isArray(rawTask?.results) ? rawTask.results[0] : null;
  if (!result)
    return {
      files: [],
      text: "",
      chat: [],
      childMessage: "",
      status: 0,
      lplans_tasks_id: Number(rawTask?.id || 0),
    };
  let resultFiles = [];
  if (Array.isArray(result.files)) {
    resultFiles = [...result.files];
  } else if (typeof result.files === "string" && result.files.trim()) {
    try {
      const parsedFiles = JSON.parse(result.files);
      resultFiles = Array.isArray(parsedFiles) ? parsedFiles : [];
    } catch {
      resultFiles = [];
    }
  }

  const chatMessages = Array.isArray(result?.chat?.chatMessage)
    ? [...result.chat.chatMessage]
    : [];

  return {
    files: resultFiles,
    text: result.answer || "",
    chat: chatMessages,
    childMessage: "",
    task_id: Number(result.id || 0),
    status: Number(result.status || 0),
    updated_ts: result.updated_ts || null,
  };
}
function isHavePupil(pupilsField) {
  if (!pupilsField) return true;
  const pupils = String(pupilsField)
    .replace(/{|}/g, "")
    .split(",")
    .map((i) => i.trim())
    .filter(Boolean);
  if (!pupils.length) return true;
  const current = String(selectedPupilId.value || localStorage.getItem("p_id") || "");
  return pupils.includes(current);
}
function statusTypeByAnswer(answer) {
  const rawStatus = Number(answer?.status || 0);
  return [1, 2, 4, 5].includes(rawStatus) ? "ready" : "no_send";
}
function resolveSubjectName(item) {
  const lang = localLang.value;
  const subjectSource = item?.subject ?? item?._subject ?? item?.lesson_view?.subject ?? {};
  let s = subjectSource;
  if (typeof s === "string") {
    try {
      s = JSON.parse(s);
    } catch {
      return s;
    }
  }

  const byKnownKeys =
    s?.[lang] ||
    s?.[lang === "kz" ? "kk" : "ru"] ||
    s?.ru ||
    s?.kz ||
    s?.kk ||
    s?.["ru-RU"] ||
    s?.["kk-KZ"] ||
    s?.name ||
    s?._data?.[lang] ||
    s?._data?.[lang === "kz" ? "kk" : "ru"] ||
    s?._data?.ru ||
    s?._data?.kz ||
    s?._data?.kk ||
    s?._data?.["ru-RU"] ||
    s?._data?.["kk-KZ"] ||
    s?._data?.name ||
    item?.subject_name ||
    item?.lesson_name ||
    item?.name_subject ||
    "";
  if (byKnownKeys) return String(byKnownKeys);

  if (s && typeof s === "object") {
    const firstString = Object.values(s).find(
      (value) => typeof value === "string" && value.trim()
    );
    if (firstString) return firstString;
  }
  return "";
}

function parseDateSafe(value) {
  if (!value) return null;
  if (typeof value === "number") {
    const num = value > 1e12 ? value : value * 1000;
    const d = new Date(num);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  const fromIso = new Date(raw);
  if (!Number.isNaN(fromIso.getTime())) return fromIso;

  const normalized = raw.replace(" ", "T");
  const fromNormalized = new Date(normalized);
  if (!Number.isNaN(fromNormalized.getTime())) return fromNormalized;

  const withZ = /\d{2}:\d{2}:\d{2}$/.test(normalized) ? `${normalized}Z` : normalized;
  const fromZ = new Date(withZ);
  if (!Number.isNaN(fromZ.getTime())) return fromZ;

  return null;
}
function filterByName(_item) {
  return true;
}
function filteringBySubject(item) {
  return (
    !(filtering.value && subject.value !== -1) ||
    Number(item.subject_id || 0) === Number(subject.value)
  );
}
function isVisibleTask(item) {
  if (taskType.value === "filtering") {
    const byStatus =
      status.value === -1 || Number(item?.answer?.status || 0) === Number(status.value);
    return byStatus && filterByName(item) && filteringBySubject(item);
  }
  return statusTypeByAnswer(item.answer) === taskType.value && filterByName(item);
}
function isLastBorder(dateTasks, task) {
  if (filtering.value) return true;
  const visible = dateTasks.tasks.filter((entry) => statusTypeByAnswer(entry.answer) === taskType.value);
  if (!visible.length) return false;
  const last = visible[visible.length - 1];
  return Number(last?.id || 0) !== Number(task?.id || 0);
}
function checkForStatus(tasks) {
  return tasks.some((item) => statusTypeByAnswer(item.answer) === taskType.value);
}
function checkToEmpty() {
  const hasVisible = groupedTasks.value.some((group) =>
    group.tasks.some((item) => isVisibleTask(item))
  );
  showAlertDanger.value = !allTasksFlat.value.length || !hasVisible;
  return showAlertDanger.value;
}
function getStatus(item) {
  const n = Number(item?.answer?.status || 0);
  const labels = statusList.value;
  if (n === 1) return { status: labels[1] || "", class: "status--yellow", num: n };
  if (n === 2) return { status: labels[2] || "", class: "status--green", num: n };
  if (n === 3) return { status: labels[3] || "", class: "status--red", num: n };
  if (n === 4) return { status: labels[4] || "", class: "status--yellow", num: n };
  if (n === 5) return { status: labels[5] || "", class: "status--yellow", num: n };
  if (n === 6) return { status: labels[6] || "", class: "status--yellow", num: n };
  return { status: labels[0] || "", class: "", num: 0 };
}
function getBg(item) {
  return Number(item?.answer?.status || 0) === 3
    ? { bg: "pink-bg", text: "danger" }
    : { bg: "", text: "" };
}
function getComment(item) {
  const pid = Number(selectedPupilId.value || 0);
  const chat = (Array.isArray(item?.answer?.chat) ? item.answer.chat : []).filter(
    (m) => Number(m?.person_id || 0) !== pid
  );
  return chat.length ? chat[chat.length - 1]?.message || "" : "";
}
function taskEndDate(item) {
  if (!item?.end_date) return { status: false, text: "", date: null };
  const end = parseDateSafe(item.end_date);
  if (!end || statusTypeByAnswer(item.answer) !== "no_send")
    return { status: false, text: "", date: null };
  return end.getTime() > Date.now()
    ? {
        status: true,
        text: t("needToPass"),
        date: end.toLocaleString(resolveLocale(), {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }),
      }
    : { status: true, text: t("timeEndPassTask"), date: null };
}
function formatGroupDate(v) {
  return new Date(v).toLocaleDateString(resolveLocale(), {
    day: "numeric",
    month: "long",
  });
}
function toggleTask(id) {
  if (!id) return;
  if (openedTaskIds.value.has(id)) openedTaskIds.value.delete(id);
  else openedTaskIds.value.add(id);
  openedTaskIds.value = new Set(openedTaskIds.value);
}
function isTaskOpen(id) {
  return openedTaskIds.value.has(id);
}
function parentRoleCheck(item) {
  return roleId.value === 3 || getStatus(item).num !== 0;
}
function checkTimeEnd(item) {
  return item?.end_date ? new Date(item.end_date).getTime() <= Date.now() : false;
}
function canEditAnswer(item) {
  return [3, 0, 6].includes(getStatus(item).num);
}
function isAnswerDisabled(item) {
  // Legacy: disabled if status not (3/0/6) OR deadline ended OR parent role
  return !canEditAnswer(item) || checkTimeEnd(item) || roleId.value === 2;
}
function isFileUploadDisabled(item) {
  return (
    !canEditAnswer(item) ||
    checkTimeEnd(item) ||
    roleId.value === 2 ||
    item.answer.files.length >= 10
  );
}
function checkMoreThen(c) {
  return c >= 10;
}
function fileInputId(taskId) {
  return `child_file_${String(taskId || 0)}`;
}
function setFileInputRef(taskId, el) {
  if (!taskId) return;
  if (el) fileInputRefs.value.set(taskId, el);
  else fileInputRefs.value.delete(taskId);
}
function resetFileInput(taskId) {
  const el = fileInputRefs.value.get(taskId);
  if (el) el.value = "";
}
function removeFile(item, idx) {
  item.answer.files.splice(idx, 1);
}
async function uploadFiles(event, item) {
  const files = Array.from(event?.target?.files || []);
  for (let i = 0; i < files.length; i += 1) {
    inProgress.value = true;
    progress.value = 0;
    try {
      const uploaded = await uploadFileMutation.mutateAsync({
        file: files[i],
        onProgress: (p) => {
          progress.value = Number(p || 0);
        },
      });
      item.answer.files.push(uploaded);
    } finally {
      inProgress.value = false;
    }
  }
  resetFileInput(item.id);
}
async function revertTask(item) {
  const id = Number(item?.answer?.task_id || 0);
  if (!id) return;
  sending.value = true;
  try {
    await updateAnswerMutation.mutateAsync({ answerId: id, payload: { status: 6 } });
    await plansQuery.refetch();
  } finally {
    sending.value = false;
  }
}
function isSubmitDisabled(item) {
  // Legacy:
  // (status not 3/0/6) || checkReadyToUpload(files, text) || inProgress || checkTimeEnd
  return (
    !canEditAnswer(item) ||
    checkReadyToUpload(item.answer.files, item.answer.text) ||
    inProgress.value ||
    checkTimeEnd(item)
  );
}
function checkReadyToUpload(files, text) {
  const list = Array.isArray(files) ? files : [];
  if (!list.length) {
    return String(text || "").replace(/\s+/g, "") === "";
  }
  return false;
}
async function submit(item) {
  if (checkTimeEnd(item) || String(item.answer.text || "").length >= 2000) return;
  sending.value = true;
  try {
    if (!Number(item.answer.task_id || 0)) {
      await createAnswerMutation.mutateAsync({
        pupil_id: selectedPupilId.value,
        lplans_tasks_id: item.answer.lplans_tasks_id,
        answer: item.answer.text || "",
        files: JSON.stringify(item.answer.files || []),
        message: item.answer.childMessage || "",
      });
    } else {
      await updateAnswerMutation.mutateAsync({
        answerId: item.answer.task_id,
        payload: {
          answer: item.answer.text || "",
          files: JSON.stringify(item.answer.files || []),
          status: 4,
          message: item.answer.childMessage || "",
        },
      });
    }
    await plansQuery.refetch();
    resetFileInput(item.id);
  } finally {
    sending.value = false;
  }
}
function openFile(file) {
  if (file?.url) window.open(file.url, "_blank", "noopener,noreferrer");
}
function openFrame(file) {
  iframe.value = {
    open: true,
    url: String(file?.url || ""),
    type: String(file?.type || ""),
  };
}
function getByFileType(file) {
  const mime = String(file?.type || "");
  const ext = String(file?.ext || "").toLowerCase();
  if (mime.startsWith("image/")) return true;
  return ["doc", "docx", "ppt", "pptx", "xls", "xlsx", "pdf"].includes(ext);
}
function onTaskContentClick(event) {
  const a = event?.target?.closest?.("a");
  if (!a || !a.href) return;
  event.preventDefault();
  window.open(a.href, "_blank", "noopener,noreferrer");
}

const setColorByRole = computed(() =>
  roleId.value === 2 ? "active-parent" : "active-pupil"
);
</script>

<style scoped>
.data__filter {
  margin-top: 0px;
}
.empty-wrap {
  margin-top: 16px;
}
.ltasks__body {
  margin: 8px 16px;
  border: 1px solid #e0e0e0;
  padding: 12px 0;
}
.resttime {
  position: relative;
  font-size: 12px;
  text-align: center;
  margin: 8px 0;
  color: #4f4f4f;
}
.resttime span {
  background: #fff;
  padding: 0 8px;
  position: relative;
  z-index: 1;
}
.resttime:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  border-top: 1px dashed #e0e0e0;
}
.task__item {
  margin-bottom: 0;
}
.task__item-title {
  color: #000;
  opacity: 0.8;
  font-size: 14px;
  font-weight:  500;
}
.task__item-subject{
  color:#828282;
  font-size: 12px;
}
.acc-item {
  width: 92%;
  border: none;
  background: transparent;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  box-sizing: border-box;
  margin-inline: auto;
}
.border-line-bottom {
  border-bottom: 1px solid #e0e0e0 !important;
}
.acc-item.is-open {
  border: 1px solid #36b453 !important;
  border-radius: 8px;
}
.task-expanded {
  border-top: none;
  border-radius: 0 0 8px 8px;
  margin: 0;
  overflow: hidden;
}
.status {
  color: #828282;
}
.red--color {
  color: #eb5757;
}
.message-alert {
  padding: 8px 20px;
}
.task__header {
  padding: 12px 24px;
  border-bottom: 1px solid #e0e0e0;
}
.task__header__title {
  /* border-bottom: 1px dotted #bdbdbd; */
}
.task__title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  opacity: 0.8;
  color: #000;
}
.task__sub-title {
  margin: 4px 0 8px;
  font-size: 12px;
  font-weight: 700;
  opacity: 0.8;
  color: #000;
}
.task__content {
  padding-bottom: 8px;
  font-size: 13px;
  color: #333;
}
.task__footer {
  padding: 12px 20px;
  background: #f5f5f5;
  border-top: 1px solid #e0e0e0;
}
.answer__head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.btn__revert {
  border: none;
  background: #36b453;
  color: #fff;
  border-radius: 4px;
  padding: 0px 10px;
  font-size: 14px;
}
.textarea,
.input {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px;
  background: #fff;
}
.textarea:disabled,
.input:disabled {
  background: #f2f2f2;
  color: #8b8b8d;
  cursor: not-allowed;
}
.chat__body {
  background: #fff;
  border-radius: 5px;
  padding: 10px 15px;
}
.chat__msg {
  max-height: 140px;
  overflow: auto;
}
.child_file--btn [type="file"] {
  height: 0;
  width: 0;
  position: absolute;
  overflow: hidden;
}
.child_file--btn [type="file"] + label {
  border: 2px dashed #bdbdbd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px;
  background: #fff;
  cursor: pointer;
}
.link-item--green .green-icon {
  color: #66bb6a;
  cursor: pointer;
}
.submit {
  width: 100%;
  border: none;
  border-radius: 4px;
  background: #36b453;
  color: #fff;
  padding: 4px 12px;
  text-transform: uppercase;
  font-size: 12px;
}
.submit:disabled {
  opacity: 0.65;
  /* background: #bdbdbd !important; */
  color: #ffffff !important;
  cursor: not-allowed;
}
.progress {
  height: 16px;
}
.progress-bar {
  background: #36b453;
  color: #fff;
  font-size: 11px;
  text-align: center;
}
.pink-bg {
  background: #fff5f7;
}
.status--red {
  color: #eb5757 !important;
}
.status--yellow {
  color: #f2a53a !important;
}
.status--green {
  color: #36b453 !important;
}
.parentAlert {
  padding: 12px 20px;
  color: #828282;
}
a {
  color: #828282;
  text-decoration: none;
}

@media screen and (min-width: 768px) {
  .data__filter {
    margin-top: 8px;
  }
  .ltasks__body {
    margin-top: 8px;
  }
}

:deep(.task__btn__group) {
  margin: 0 !important;
}

:deep(.switch-btn-group-big) {
  margin: 0 !important;
}

:deep(.tabs-desktop) {
  border-top: 1px solid #e0e0e0 !important;
}

:deep(.tabs-mobile.active-pupil .tab-btn.active) {
  border-bottom-color: #36b453 !important;
}

:deep(.tabs-mobile.active-parent .tab-btn.active) {
  border-bottom-color: #00c2ff !important;
}

:deep(.tabs-mobile .tab-btn) {
  position: relative;
}

@media screen and (min-width: 768px) {
  :deep(.task__btn__group) {
    position: fixed !important;
    left: 0 !important;
    right: 0 !important;
    top: 56px !important;
    height: 72px !important;
    margin: 0 5% 0 15% !important;
    max-width: 1350px !important;
    z-index: 100 !important;
  }
  :deep(.switch-btn-group-big) {
    position: fixed !important;
    left: 0 !important;
    right: 0 !important;
    top: 56px !important;
    height: 72px !important;
    margin: 0 5% 0 15% !important;
    max-width: 1350px !important;
  }
  .data__filter {
    margin-top: 50px;
  }
  .message-alert{
    margin: 0 32px;
  }
  .task-expanded {
    margin: 0 32px 10px;
  }
  .ltasks__body {
    margin: 8px 36px;
    padding: 24px 0;
  }
}
</style>
